import { Icon, Tooltip } from '@cotera/client/app/components';
import { Text } from '@cotera/client/app/components/ui';
import { cn } from '@cotera/client/v0/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';

export const Title: React.FC<{
  title?: string;
  description?: string;
  help?: string;
  className?: string;
  children?: React.ReactNode;
}> = ({ title, description, help, className, children }) => {
  return (
    <div className={cn(className, 'flex flex-row items-center gap-2 mb-2')}>
      <Text.Title subtitle={description} type="section" title={title}>
        {children}
      </Text.Title>
      {help && <Help help={help} />}
    </div>
  );
};

export const Help: React.FC<{
  help: string;
}> = ({ help }) => {
  return (
    <Tooltip tooltipContent={help} side="top">
      <div>
        <Icon icon="information-circle" />
      </div>
    </Tooltip>
  );
};

const configSectionVariants = cva('w-full flex gap-2', {
  variants: {
    padding: {
      default: 'py-4',
      firstItem: 'pb-4',
    },
  },
  defaultVariants: {
    padding: 'default',
  },
});

export const ConfigSection: React.FC<
  {
    title: string;
    children: React.ReactNode;
    className?: string;
  } & VariantProps<typeof configSectionVariants>
> = ({ title, children, className, padding }) => {
  return (
    <div className={cn(configSectionVariants({ padding, className }))}>
      <div className="text-sm text-foreground/50 w-32">{title}</div>
      <div className="w-full flex-grow justify-end flex">{children}</div>
    </div>
  );
};

export { configSectionVariants };
